import {UsersAuthorization} from '../users';
import {APIURL} from "../../constants";
import axios from 'axios'

export default {
	namespaced: true,
	state: {
		canEdit: false,
		canShow: false,
		canDelete: false,
		canAdd: false,
		privilegesChecked: false,

	},
	getters: {
		canEdit(state)
		{

			return state.canEdit;
		},

		canShow(state)
		{
			return state.canShow
		},

		canDelete(state)
		{
			return state.canDelete;
		},

		canAdd(state)
		{
			return state.canAdd;
		},

		privilegesChecked(state)
		{
			return state.privilegesChecked
		},




	},
	actions: {
		privileges(context)
		{
			UsersAuthorization.authorize("", undefined, 
				(isAdmin) => {
					
					context.commit('privileges', isAdmin)
					
				}, (err) => {
					console.log(err);
				})
		},


	},

	mutations: {
		

		privileges(state, isAdmin)
		{
			state.canEdit = isAdmin;
			state.canShow = isAdmin;
			state.canDelete = isAdmin;
			state.canAdd = isAdmin;
			state.privilegesChecked = true;

			
		},


	}

}